export default __webpack_public_path__ + "static/media/c-introduce-item-img-05.45654aab.png";